import { render, staticRenderFns } from "./IconeDocRenderer.vue?vue&type=template&id=01b9fdc7&"
import script from "./IconeDocRenderer.vue?vue&type=script&lang=js&"
export * from "./IconeDocRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports